export default __webpack_public_path__ + "static/media/switch-icon.be7bb0ba.svg";